export const NO_RESULTS = 'NO_RESULTS';
